import { Skeleton } from "@somethings-ui/web";
import { cn } from "@/lib/utils";

const PLACEHOLDER_ROWS: ReadonlyArray<{ direction: "incoming" | "outgoing"; width: string }> = [
  { direction: "incoming", width: "w-40" },
  { direction: "incoming", width: "w-56" },
  { direction: "outgoing", width: "w-48" },
  { direction: "incoming", width: "w-32" },
  { direction: "outgoing", width: "w-52" },
];

export function AttentionThreadSkeleton() {
  return (
    <div aria-hidden className="flex flex-1 flex-col gap-4 p-4">
      {PLACEHOLDER_ROWS.map((row, index) => (
        <div
          key={index}
          className={cn(
            "flex",
            row.direction === "outgoing" ? "justify-end" : "justify-start",
          )}
        >
          <Skeleton className={cn("h-9 rounded-xl", row.width)} />
        </div>
      ))}
    </div>
  );
}
